import { useState, useEffect } from 'react'
import EditAdtr from './editAdtr'
import Spinner from 'react-bootstrap/Spinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import BaseService from '../../../services/BaseService'
import DataGrid from '../../GenericComponents/DataGrid'
import { Column } from 'primereact/column'
import CommonService from "../../../services/CommonService"

const SearchResultContainer = (props) => {
  const [editAdtr, setEditAdtr] = useState(false);
  const [selectedAdtrInfo, setSelectedAdtrtInfo] = useState([]);
  const {finalSaleId} = props;
  const [cdiacAdtrs, setCdiacAdtrs] = useState([])
  const [isLoading, setIsLoading] = useState(true);

  const viewEditFormatter = (row) => {
    return (
      <div style={{
        textAlign: "center",
        lineHeight: "normal"
      }}>
        <FontAwesomeIcon icon={faPencilAlt} className="custom-icon" onClick={(e)=>onRowClick(e, row)}/> 
      </div>
    );
  }
  const onRowClick = (e, row) => {
    // e.preventDefault();
    setSelectedAdtrtInfo(row);
    setEditAdtr(true);
  }

  const getAdtrsByFinalSaleId = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAdtrByFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
          "finalSaleId": finalSaleId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setCdiacAdtrs(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }
  useEffect(() => {
    if (finalSaleId){
      getAdtrsByFinalSaleId();
    }
    // eslint-disable-next-line
  }, [finalSaleId]);

  const columns = [{
    dataField: 'fiscalYrEndDate',
    text: 'Fiscal Year End Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.fiscalYrEndDate),
  },{
    dataField: 'rptPeriodBeginBalAmt',
    text: 'Reporting Period Begin Balance Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.rptPeriodBeginBalAmt),
  },{
    dataField: 'filingDate',
    text: 'Filing Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.filingDate),
  }, {
    dataField: 'statusFlag',
    text: 'Status Flag',
    sort: true,
  },
  {
    dataField: "",
    text: "Action",
    formatter: viewEditFormatter,
  }
  ];

  const handleModalClose = () => {
    setEditAdtr(false);
    getAdtrsByFinalSaleId();
  }


  return (
    <>
      <hr/>
      {isLoading && <Spinner animation="border" variant="primary" />}
      <div className="form">
        <h2>Search Result: </h2>
        <DataGrid
            title="Annual Debt Transparency Reports"
            dataSource={cdiacAdtrs}
            sortField='adtrId'
            searchToolTip="Use the search feature to quickly retrieve the system code values"
            emptyDataMessage='No data available to display'
            >
            {columns.map((column, i) => {
                return (
                <Column 
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort} 
                body={column.formatter}
                hidden={column.hidden}
                />)
                }) 
            } 
        </DataGrid>
      </div>
      {editAdtr && <EditAdtr onModalClose={() => handleModalClose()} adtrInfo={selectedAdtrInfo} />}
    </>
  )
}

export default SearchResultContainer
